import { Link } from "react-router-dom";
import { StatusBadges } from "@/components/StatusBadge";
import { SERVICE_LABELS } from "@/lib/booking";
import { atl, fareLabel, shortAddress } from "@/lib/format";

export function TripCard({ booking, index = 0 }) {
  const d = atl(booking.scheduled_at);
  return (
    <Link
      to={`/trips/${booking.id}`}
      data-testid={`trip-card-${booking.id}`}
      style={{ animationDelay: `${index * 60}ms` }}
      className="lux-card rise flex items-center gap-4 p-4 transition-[border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-gold/40 sm:p-5"
    >
      <div className="flex w-14 shrink-0 flex-col items-center rounded-xl border border-line bg-elevated py-2">
        <span className="text-[10px] uppercase tracking-[0.2em] text-mist">{d.format("MMM")}</span>
        <span className="font-display text-2xl leading-none text-ivory">{d.format("D")}</span>
        <span className="mt-1 text-[10px] text-faint">{d.format("h:mm A")}</span>
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-[11px] uppercase tracking-[0.18em] text-gold">
          {SERVICE_LABELS[booking.service_type]} <span className="text-faint">·</span>{" "}
          <span className="normal-case tracking-normal text-mist">{booking.vehicle_name}</span>
        </p>
        <p className="mt-1 truncate text-sm text-ivory">{shortAddress(booking.pickup.address)}</p>
        <p className="truncate text-xs text-mist">
          → {booking.dropoff ? shortAddress(booking.dropoff.address) : `${booking.hours} hours, as directed`}
        </p>
      </div>
      <div className="flex shrink-0 flex-col items-end gap-2">
        <span className="font-display text-lg text-ivory" data-testid={`trip-card-fare-${booking.id}`}>
          {fareLabel(booking)}
        </span>
        <StatusBadges booking={booking} testId={`trip-card-${booking.id}`} />
      </div>
    </Link>
  );
}

export function TripCardSkeleton() {
  return <div className="lux-card h-[92px] animate-pulse bg-surface/60" />;
}
